import { render, staticRenderFns } from "./GenericProcess.vue?vue&type=template&id=39da33de"
import script from "./GenericProcess.vue?vue&type=script&lang=js"
export * from "./GenericProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports